import { render, staticRenderFns } from "./SmsPreview.vue?vue&type=template&id=4defc22e&scoped=true"
import script from "./SmsPreview.vue?vue&type=script&lang=js"
export * from "./SmsPreview.vue?vue&type=script&lang=js"
import style0 from "./SmsPreview.vue?vue&type=style&index=0&id=4defc22e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4defc22e",
  null
  
)

export default component.exports